import { IManualSuscriptionPersonName } from '../../../../common/interfaces'

export const formatPersonName = (person: IManualSuscriptionPersonName): string => {
  const firstName = person.nombres.trim().split(/\s+/)[0]
  const lastName = person.apellidoPaterno || person.apellidoMaterno

  return lastName ? `${firstName} ${lastName}` : firstName
}
